<div class="input-group form-group-no-border filter-item d-flex justify-content-between">
    <label class="label text-end" [innerText]="filter.label" [class.required-field]="filter.required"></label>
    <ngb-dropdown [data]="data"
        (onSelect)="valueChange()" 
        (onDeSelect)="valueChange()"
        (onDeSelectAll)="valueChange()"
        [(ngModel)]="value"
        class="bg-default shadow w-200px mr-n2" [settings]="dropdownSettings">
    </ngb-dropdown>
</div>